export default __webpack_public_path__ + "static/V2-Cartons-Purifier&Pro-05470e2952221dbaca03347a9446aa06.png";